// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"f4a59929","63":"1aed1f2b","213":"4dc48185","361":"03b13af5","662":"f4a59929"}[chunkId] + ".chunk.css";
};